import { render } from "./WidgetOrdersLatest10.vue?vue&type=template&id=23fbb0fe&scoped=true&ts=true"
import script from "./WidgetOrdersLatest10.vue?vue&type=script&lang=ts"
export * from "./WidgetOrdersLatest10.vue?vue&type=script&lang=ts"

import "./WidgetOrdersLatest10.vue?vue&type=style&index=0&id=23fbb0fe&scoped=true&lang=css"

import exportComponent from "D:\\YellowBeardProject\\dobby\\dobbyshopadmin\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-23fbb0fe"]])

export default __exports__